export type KeyCommunityEventParams = {
  communityId: string | number;
  eventId: string;
};

export const keyCommunityEvent = ({
  communityId,
  eventId,
}: KeyCommunityEventParams) =>
  ["community-event", String(communityId), eventId] as const;

export const keyCommunityEventsByCommunity = (communityId: string | number) =>
  ["community-event", String(communityId)] as const;
